// Home.js
import React, { useContext } from "react";
import { AuthContext } from "../services/authContext";
import { useNavigate } from "react-router-dom";

const Home = () => {
  const { authenticated, loading, error } = useContext(AuthContext);
  const navigate = useNavigate();
  return (
    <>
      <h1>Home Page</h1>
      <label>{loading ? "Loading..." : error ? `Error: ${error}` : authenticated ? "Welcome, User!" : "Please log in."}</label>
      {authenticated && navigate && (
        <div>
          <button style={{ marginTop: 10 }} onClick={() => navigate("/LocationFilter")}>
            Create a tour
          </button>
        </div>
      )}
    </>
  );
};

export default Home;
